import Vue from 'vue'
import VueResource from 'vue-resource'
import mixins from '../mixins.js'
import changePortionsOrComponents from './changePortionsOrComponents.vue'

if ($('#change_portions_or_components').length) {
  Vue.use(VueResource)

  new Vue({
    el: '#change_portions_or_components',
    components: {
      changePortionsOrComponents
    },
    mixins: [mixins],
    data: {

    },
    methods: {

    }
  })
}
